export default __webpack_public_path__ + "media/flags/ae-68e81433.svg";